import { render, staticRenderFns } from "./import-data-history.vue?vue&type=template&id=1f4aa8d8&scoped=true&"
import script from "./import-data-history.vue?vue&type=script&lang=js&"
export * from "./import-data-history.vue?vue&type=script&lang=js&"
import style0 from "./import-data-history.vue?vue&type=style&index=0&id=1f4aa8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4aa8d8",
  null
  
)

export default component.exports